export const selectMaAccPgContainer = (state) => state.containers.manualAccessPageReducer;
export const selectLoginAutomatedPageContainer = (state) => state.containers.loginAutomatedPageReducer;

// Need to use .get, beucase reducer defaulState was created by using ImmutableJS
export const selectLoading = (state) => selectMaAccPgContainer(state).get('loading');
export const selectFormPhoneRequestConfig = (state) => selectMaAccPgContainer(state).get('formRequestConfig');
export const selectPinForAuthorizeLoaded = (state) => selectMaAccPgContainer(state).get('pinForAuthorizeLoaded');
export const selectPhoneNumber = (state) => selectMaAccPgContainer(state).get('phoneNumber');
export const selectPinNumber = (state) => selectMaAccPgContainer(state).get('pinNumber');
export const selectpinForAuthorizeError = (state) => selectMaAccPgContainer(state).get('pinForAuthorizeError');
export const selectsubscriptionUriError = (state) => selectMaAccPgContainer(state).get('subscriptionUri');
export const selectUrlFormToSubscription = (state) => selectMaAccPgContainer(state).get('urlFormToSubscription');
export const selectContactMeByTelOnly = (state) => selectMaAccPgContainer(state).get('contactMeByTelOnly');
export const selectEmail = (state) => selectMaAccPgContainer(state).get('email');

/* ----------  Selector for loginAutomatedPageReducer  ----------*/
export const selectInitialDataConfig = (state) => selectLoginAutomatedPageContainer(state).get('initialDataConfig');





// WEBPACK FOOTER //
// ./src/containers/ManualAccessPage/selectors.js